import { render, staticRenderFns } from "./CompensationPointsTable.vue?vue&type=template&id=0c11eb64&"
import script from "./CompensationPointsTable.vue?vue&type=script&lang=js&"
export * from "./CompensationPointsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports